/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Menu, X, Home, LogOut, ChevronLeft, ChevronDown, ChevronRight,
  Upload, Users, Wallet, ShoppingCart, FileText, CalendarDays, KeyRound, BarChart3, History,
} from "lucide-react";
import { GetUserProfile, SignOut } from "../services/Actions/authActions";
import ThemeToggle from "../Components/ThemeToggle";

const NAV = [
  {
    label: "Dashboard",
    icon: <Home size={18} />,
    path: "/it/home",
  },
  {
    label: "Loans",
    icon: <FileText size={18} />,
    children: [
      { label: "Upload Loans", icon: <Upload size={15} />, path: "/it/upload-loans" },
      { label: "Upload Staff Loans", icon: <Upload size={15} />, path: "/it/upload-staff-loans" },
      { label: "Update Loans by Date", icon: <CalendarDays size={15} />, path: "/it/upload-loans-by-date" },
      { label: "Deduction Analysis", icon: <BarChart3 size={15} />, path: "/it/loan-analysis" },
    ],
  },
  {
    label: "Mart",
    icon: <ShoppingCart size={18} />,
    children: [
      { label: "Upload Mart", icon: <Upload size={15} />, path: "/it/upload-mart" },
      { label: "Upload Staff Mart", icon: <Upload size={15} />, path: "/it/upload-staff-mart" },
      { label: "Update Mart by Date", icon: <CalendarDays size={15} />, path: "/it/upload-mart-by-date" },
    ],
  },
  {
    label: "Fund",
    icon: <Wallet size={18} />,
    children: [
      { label: "Upload Funds", icon: <Upload size={15} />, path: "/it/upload-funds" },
      { label: "Upload Staff Funds", icon: <Upload size={15} />, path: "/it/upload-staff-funds" },
      { label: "Update Funds by Date", icon: <CalendarDays size={15} />, path: "/it/upload-funds-by-date" },
      { label: "Contribution Analysis", icon: <BarChart3 size={15} />, path: "/it/fund-analysis" },
    ],
  },
  {
    label: "Members",
    icon: <Users size={18} />,
    children: [
      { label: "Reset Member Account", icon: <KeyRound size={15} />, path: "/it/reset-member" },
      { label: "Upload Members", icon: <Upload size={15} />, path: "/it/upload-members" },
    ],
  },
  {
    label: "Audit Trail",
    icon: <History size={18} />,
    path: "/it/audit-trail",
  },
];

function RenderITOfficerPage({ children, title }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openSections, setOpenSections] = useState(["Loans", "Mart", "Fund", "Members"]);

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { user } = auth;

  useEffect(() => {
    dispatch(GetUserProfile());
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(SignOut());
    setTimeout(() => window.location.reload(false), 500);
  };

  const toggleSection = (label) => {
    setOpenSections((prev) =>
      prev.includes(label) ? prev.filter((s) => s !== label) : [...prev, label]
    );
  };

  const isChildActive = (item) =>
    item.children?.some((c) => location.pathname === c.path);

  const sidebarWidth = isCollapsed ? "w-[68px]" : "w-64";
  const mainPadding = isCollapsed ? "lg:pl-[68px]" : "lg:pl-64";

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex py-1 transition-colors duration-300">
      {/* SIDEBAR */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 ${sidebarWidth} bg-white dark:bg-gray-900 border-r border-slate-200 dark:border-gray-700 transform transition-all duration-300 ease-in-out lg:translate-x-0 ${isMobileMenuOpen ? "translate-x-0 !w-64" : "-translate-x-full"}`}
      >
        <div className="h-full flex flex-col">
          {/* Logo */}
          <div className="p-3 flex items-center justify-between border-b border-slate-100 dark:border-gray-700">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 bg-cyan-600 rounded-lg flex items-center justify-center text-white font-bold text-xs flex-shrink-0">
                IT
              </div>
              {!isCollapsed && (
                <div>
                  <p className="text-sm font-bold text-slate-800 dark:text-slate-100 leading-tight">IT Officer</p>
                  <p className="text-xs text-slate-400 dark:text-slate-500">Control Panel</p>
                </div>
              )}
            </div>
            <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              className="hidden lg:flex p-1.5 rounded-lg border border-slate-200 dark:border-gray-600 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-gray-800 transition-colors"
            >
              <ChevronLeft size={14} style={{ transform: isCollapsed ? "rotate(180deg)" : "none", transition: "transform 0.3s" }} />
            </button>
            <button onClick={() => setIsMobileMenuOpen(false)} className="lg:hidden p-2 text-slate-500">
              <X size={18} />
            </button>
          </div>

          {/* Nav */}
          <nav className="flex-1 px-2 py-2 overflow-y-auto space-y-0.5 custom-scrollbar">
            {NAV.map((item) => {
              if (!item.children) {
                // Simple link
                const isActive = location.pathname === item.path;
                return (
                  <button
                    key={item.path}
                    onClick={() => { history.push(item.path); setIsMobileMenuOpen(false); }}
                    title={isCollapsed ? item.label : ""}
                    className={`w-full flex items-center ${isCollapsed ? "justify-center" : "gap-3"} px-3 py-2.5 rounded-lg transition-all group ${isActive ? "bg-cyan-600 text-white shadow-sm" : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800"}`}
                  >
                    <span className={isActive ? "text-white" : "text-slate-400 group-hover:text-cyan-600 dark:group-hover:text-cyan-400"}>
                      {item.icon}
                    </span>
                    {!isCollapsed && <span className="text-sm font-semibold">{item.label}</span>}
                  </button>
                );
              }

              // Section with children
              const sectionOpen = openSections.includes(item.label);
              const hasActive = isChildActive(item);
              return (
                <div key={item.label}>
                  <button
                    onClick={() => !isCollapsed && toggleSection(item.label)}
                    title={isCollapsed ? item.label : ""}
                    className={`w-full flex items-center ${isCollapsed ? "justify-center" : "justify-between"} px-3 py-2.5 rounded-lg transition-all group ${hasActive ? "text-cyan-600 dark:text-cyan-400" : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800"}`}
                  >
                    <div className={`flex items-center ${isCollapsed ? "" : "gap-3"}`}>
                      <span className={hasActive ? "text-cyan-600 dark:text-cyan-400" : "text-slate-400 group-hover:text-cyan-600 dark:group-hover:text-cyan-400"}>
                        {item.icon}
                      </span>
                      {!isCollapsed && <span className="text-sm font-semibold">{item.label}</span>}
                    </div>
                    {!isCollapsed && (
                      <ChevronDown size={14} className={`transition-transform ${sectionOpen ? "rotate-180" : ""} text-slate-400`} />
                    )}
                  </button>

                  {/* Children */}
                  {!isCollapsed && sectionOpen && (
                    <div className="ml-4 pl-3 border-l-2 border-slate-100 dark:border-gray-700 space-y-0.5 mt-0.5 mb-1">
                      {item.children.map((child) => {
                        const isActive = location.pathname === child.path;
                        return (
                          <button
                            key={child.path}
                            onClick={() => { history.push(child.path); setIsMobileMenuOpen(false); }}
                            className={`w-full flex items-center gap-2 px-2.5 py-2 rounded-lg text-xs font-semibold transition-all ${isActive ? "bg-cyan-50 dark:bg-cyan-900/20 text-cyan-700 dark:text-cyan-400" : "text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-gray-800 hover:text-slate-700 dark:hover:text-slate-200"}`}
                          >
                            <span>{child.icon}</span>
                            {child.label}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>

          {/* Footer */}
          <div className="p-2 border-t border-slate-100 dark:border-gray-700">
            {!isCollapsed ? (
              <>
                <div className="flex items-center gap-2 mb-2 px-2">
                  <img
                    className="w-8 h-8 rounded-full border-2 border-white dark:border-gray-600 shadow-sm flex-shrink-0"
                    src={user?.profile_image || "/images/dev/avarta2.jpeg"}
                    alt="User"
                  />
                  <div className="overflow-hidden">
                    <p className="text-xs font-bold text-slate-800 dark:text-slate-100 truncate">{user?.name || "IT Officer"}</p>
                    <p className="text-xs text-cyan-600 dark:text-cyan-400 font-medium">IT Officer</p>
                  </div>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2 px-2 py-2 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-600 text-rose-600 rounded-xl hover:bg-rose-50 dark:hover:bg-gray-700 transition-colors font-semibold text-sm shadow-sm"
                >
                  <LogOut size={15} /> Logout
                </button>
              </>
            ) : (
              <button onClick={handleLogout} title="Logout" className="w-full flex items-center justify-center py-2 text-rose-600 hover:bg-rose-50 dark:hover:bg-gray-700 rounded-xl transition-colors">
                <LogOut size={18} />
              </button>
            )}
          </div>
        </div>
      </aside>

      {/* MAIN */}
      <main className={`flex-1 flex flex-col min-w-0 ${mainPadding} transition-all duration-300`}>
        {/* Top bar */}
        <header className="sticky top-0 z-40 bg-white/60 dark:bg-gray-900/60 backdrop-blur-md border-b border-slate-200 dark:border-gray-700 px-4 py-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden p-2 rounded-lg bg-slate-100 dark:bg-gray-800 text-slate-600 dark:text-slate-300">
                <Menu size={18} />
              </button>
              <h1 className="text-sm font-bold text-slate-800 dark:text-slate-100 hidden sm:block">{title}</h1>
            </div>
            <div className="flex items-center gap-3">
              <ThemeToggle />
              <img
                className="w-7 h-7 rounded-full cursor-pointer ring-2 ring-transparent hover:ring-cyan-500 transition-all shadow-sm"
                src={user?.profile_image || "/images/dev/avarta2.jpeg"}
                alt="Avatar"
              />
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{title}</h2>
            {title && <div className="h-1 w-12 bg-cyan-600 rounded-full mt-2" />}
          </div>
          <div className="animate-in fade-in duration-500">{children}</div>
        </div>
      </main>

      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} />
      )}
    </div>
  );
}

export default RenderITOfficerPage;
